import React from "react";
import { Form, Modal, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import styled from "styled-components";
import Button from "atoms/Button";

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
    padding-bottom: 30px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
`;

const ALLOWED_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "image/png",
  "image/jpeg",
];

const AddClientDocument = ({ showAddModal, onClose, onFinish, setFile, isUpdating, form }) => {
  const handleClose = () => {
    onClose();
    form.resetFields();
  };

  return (
    <StyledModal title="Add Document" visible={showAddModal} onCancel={handleClose} width={600} footer={[]}>
      <Form layout="vertical" colon={false} form={form} onFinish={onFinish}>
        <Form.Item
          label="Attachment"
          name="file"
          valuePropName="fileList"
          getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
          rules={[{ required: true, message: "Please upload a file." }]}
        >
          <Upload
            listType="picture"
            maxCount={1}
            showUploadList={true}
            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.jpeg"
            beforeUpload={(file) => {
              if (!ALLOWED_TYPES.includes(file.type)) {
                message.error("This file type is not supported.");
                return Upload.LIST_IGNORE;
              }
              return true;
            }}
            customRequest={({ file, onSuccess }) => {
              // Just hold on to the raw File — the parent uploads it straight
              // to S3 via a presigned url (see useClientDocumentUpload), the
              // same direct-to-S3 flow IdentityDocUpload uses.
              setFile(file);
              onSuccess();
            }}
          >
            <Button type="primary" icon={<UploadOutlined />}>
              Click to Upload
            </Button>
          </Upload>
        </Form.Item>

        <div className="text-end">
          <Button type="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={isUpdating}>
            Save
          </Button>
        </div>
      </Form>
    </StyledModal>
  );
};

export default AddClientDocument;
